import { render, staticRenderFns } from "./MPreRegister.vue?vue&type=template&id=42527864&scoped=true&"
import script from "./MPreRegister.vue?vue&type=script&lang=ts&"
export * from "./MPreRegister.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42527864",
  null
  
)

export default component.exports